var map = {
	"./beauty_hair.svg": "g35E",
	"./booking_list.svg": "OPbc",
	"./close_eye.svg": "Tv3S",
	"./data_center.svg": "QjNt",
	"./default_head.svg": "8Vs5",
	"./duanxin.svg": "Ww1l",
	"./goods_manage.svg": "3jpC",
	"./less_icon.svg": "NB7/",
	"./market_apps.svg": "h6Zb",
	"./member.svg": "Zwlh",
	"./member_ship.svg": "LVfw",
	"./money_manage.svg": "qDd8",
	"./open_eye.svg": "cATe",
	"./opening_order.svg": "ZLWe",
	"./order_manage.svg": "X4l/",
	"./search.svg": "EqOI",
	"./setting_manage.svg": "x0Yn",
	"./sort.svg": "Nbau",
	"./store_manage.svg": "FkDQ",
	"./tixing.svg": "HH6L",
	"./tuisong.svg": "KHM2",
	"./vip_icon.svg": "PAuy",
	"./weixin.svg": "TVpX",
	"./workbench_manage.svg": "OTzZ",
	"./yuyue.svg": "Pj1G"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VZYf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg nonrecursive \.svg$
// module id = VZYf
// module chunks = 78